import { CategorySummary } from "../types/store";

export const getCategoryKey = (category: CategorySummary) =>
  category.slug ?? category.name.toLowerCase().replace(/\s+/g, "-");

export const getCategoryCoverImage = (category: CategorySummary) => category.image?.trim() || "";
